<template>
    <div>
        <order v-for="order in orders.data" :order="order" :key="order.id" @review="review"></order>

        <product-feedback :id="feedbackProductId"></product-feedback>

        <div v-if="orders && orders.meta && orders.meta.last_page > 1" class="mb-5">
            <pagination :current-page="orders.meta.current_page" :total-pages="orders.meta.last_page" @setPage="setPage"></pagination>
        </div>

        <return></return>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import Order from './Order';

    export default {
        name: 'CustomerOrders',
        components: {
            order: Order,
        },
        props: {
            page: {
                type: Number,
                required: false,
                default: null
            }
        },
        data () {
            return {
                feedbackProductId: 0,
            }
        },
        mounted: function () {
            this.load();
        },
        methods: {
            ...mapMutations('customer', [
                'setOrders',
                'setPaymentServices'
            ]),

            ...mapMutations('product', [
                'openFeedbackModal',
            ]),

            load (page) {
                let _this = this;

                axios.get('/account/orders/' + (this.page ? ('?page=' + this.page) : ''))
                    .then(response => {
                        _this.setOrders(response.data);

                        if (response.data.paymentServices) {
                            _this.setPaymentServices(response.data.paymentServices);
                        }

                        _this.$nextTick(function() {
                            let elements = document.getElementsByClassName('order');

                            if (elements.length) {
                                elements[0].scrollIntoView({
                                    behavior: 'smooth',
                                });
                            }
                        })
                    });
            },

            review (productId) {
                this.feedbackProductId = productId;

                this.openFeedbackModal('review');
            },

            setPage (page) {
                this.load(page);
            }
        },
        computed: {
            ...mapState('customer', [
                'orders',
            ]),

            /*returnDialog: {
                get () {
                    return !!this.$store.state.customer.return;
                },
                set (value) {
                    this.$store.commit('customer/return', value);
                }
            }*/
        }
    }
</script>
